import { render, staticRenderFns } from "./Infography.vue?vue&type=template&id=b6607d9a&"
import script from "./Infography.vue?vue&type=script&lang=ts&"
export * from "./Infography.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports